module.exports = __webpack_public_path__ + "235e74119543e72c3b2b6cd6275d76ca.png";